import { render } from "./IphoneButton.vue?vue&type=template&id=75a21d60&scoped=true"
import script from "./IphoneButton.vue?vue&type=script&lang=js"
export * from "./IphoneButton.vue?vue&type=script&lang=js"

import "./IphoneButton.vue?vue&type=style&index=0&id=75a21d60&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a21d60"]])

export default __exports__